"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getProp = _interopRequireDefault(require("./get-prop"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var postToTitleCard = function postToTitleCard(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields,
    callToActionText = _ref.callToActionText;
  return {
    sys: {
      id: (0, _getProp["default"])(sys, 'id'),
      contentType: {
        sys: {
          id: 'card'
        }
      }
    },
    fields: {
      cardType: 'title',
      title: (0, _getProp["default"])(fields, 'title'),
      callToActionText: callToActionText,
      link: {
        sys: sys,
        fields: fields
      }
    }
  };
};
var _default = postToTitleCard;
exports["default"] = _default;